import { computed } from 'vue'
import { useI18n, useRoute, useRouter } from '@fusapp-work/shell'

import { useConsoleDetailHeading } from './useConsoleDetailHeading'

/** Console v2.dc.html:3039-3044 navDefs: sections and group order of the approved shell. */
const sections = ['companies', 'users', 'roles', 'audit', 'entra', 'welcome', 'channels', 'templates', 'transactions', 'secrets', 'connections', 'keys', 'regions'] as const
export type ConsoleSection = typeof sections[number]
const groupOrder = ['organization', 'identity', 'communication', 'integration', 'infrastructure'] as const
export type ConsoleNavigationGroup = typeof groupOrder[number]
function group(key: ConsoleSection): ConsoleNavigationGroup {
  if (key === 'channels' || key === 'templates' || key === 'transactions') return 'communication'
  if (key === 'entra' || key === 'welcome') return 'identity'
  if (key === 'secrets' || key === 'connections' || key === 'keys') return 'integration'
  if (key === 'regions') return 'infrastructure'
  return 'organization'
}
function routeName(key: ConsoleSection) { return `${group(key)}-${key}` }
export function useConsoleNavigation(withDetail = true) {
  const router = useRouter()
  const route = useRoute()
  const { t } = useI18n()
  const section = computed(() => sections.find(item => item === route.meta['shellSection']) ?? 'companies')
  const detail = withDetail ? useConsoleDetailHeading() : computed(() => null)
  const title = computed(() => detail.value?.title ?? t(`consoleShell.${section.value}`))
  const description = computed(() => detail.value?.description ?? t(`consoleShell.${section.value}Description`))
  const items = computed(() => sections.filter(key => router.hasRoute(routeName(key))).map(key => ({
    key, group: group(key), label: t(`consoleShell.${key === 'channels' ? 'channelsNavigation' : key === 'transactions' ? 'transactionsNavigation' : key}`),
    to: { name: routeName(key), query: group(key) === 'organization' && typeof route.query['orgId'] === 'string' ? { orgId: route.query['orgId'] } : {} },
  })))
  const groups = computed(() => groupOrder.map(key => ({ key, label: t(`consoleShell.${key}`), items: items.value.filter(item => item.group === key) })).filter(group => group.items.length))
  return { section, title, description, items, groups }
}
